import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ForceAlert } from '../../models';

@Component({
    standalone: true,
    imports: [CommonModule, IonicModule],
    selector: 'abs-force-alerts',
    template: `
        <div class="warning gutter-padding" *ngFor="let alert of alerts">
            {{ alert.message }}
            <button class="dismiss-btn" (click)="dismiss.emit(alert)">&#x2715;</button>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }
            .warning {
                justify-content: space-between;
                text-align: left;
            }
        `
    ]
})
export class ForceAlertsComponent {
    @Input() alerts: ForceAlert[] = [];
    @Output() dismiss = new EventEmitter<ForceAlert>();
}
